// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607160533/js/" + chunkId + "." + {"44":"84d052e8","225":"3460486f","481":"18102de8","486":"6b83a929","770":"6bf63501"}[chunkId] + ".0.37096648386684994.chunk.js";
};